import React from 'react';
import styles from './Frame.module.scss';

const Frame = () => (
    <React.Fragment>
        <div className={styles['frame-top']} />
        <div className={styles['frame-bottom']} />
        <div className={styles['frame-left']} />
        <div className={styles['frame-right']} />
    </React.Fragment>
);

export default Frame;



// WEBPACK FOOTER //
// ./src/components/common/frame/Frame.jsx